import { Injectable, inject } from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';

import {User} from '../model/user/user.model';
import {MedicalQuestionnaire} from '../model/user/medical-questionnaire.model';
import {Event} from '../model/event/event.model';
import {FormatService} from 'src/app/services/format.service';
import {SchoolLevel} from '../model/user/school-level.model';
import {YoungEditInformationDto} from '../model/dto/young-edit-information.dto';
import {YoungWebservice} from './webservices/young.webservice';
import {dateInscription} from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class YoungCreationDataService {
    private readonly formatService = inject(FormatService);
    private readonly youngWS = inject(YoungWebservice);


    schoolLevels: SchoolLevel[];
    private dataCurrentUser = new BehaviorSubject(null);
    public currentUserMessager = this.dataCurrentUser.asObservable();
    public currentUserMessagerOther = this.dataCurrentUser.asObservable();
    private listOfAllEvent = new BehaviorSubject([]);
    public currentListOfAllEvent = this.listOfAllEvent.asObservable();
    public currentListOfAllEventOther = this.listOfAllEvent.asObservable();
    private readonly _registerEvent: Map<number, Event[]> = new Map<number, Event[]>();
    private dataCurrentUserOther = new BehaviorSubject(null);
    private listOfAllEventOther = new BehaviorSubject([]);
    private readonly registerEventOther: Map<number, Event[]> = new Map<number, Event[]>();

    private readonly user = new Subject();
    public userObservable = this.user.asObservable();
    private readonly _sdlvTabs: {
    activity?: unknown[], //required
    activityUnsubscribed?: unknown[]; //required
    height?: number, //not required
    weight?: number, //not required

    activityHolidays?: boolean, //not required
    nameActivityHolidays?: string, //not required
    sportPraticated?: boolean, //not required
    nameSportPraticated?: string, //not required

    validatedMedicalCertificate?: boolean, //not required
    validatedDateMedicalCertificate?: Date, //not required
    certifFile?: File,

    hasParentalAuthorization?: boolean,
    yearsValidationDate?: Date,

    medicalQuestionnaire?: MedicalQuestionnaire

  } = {};
    private readonly _sdlvTabsOther: {
    activity?: unknown[], //required
    activityUnsubscribed?: unknown[]; //required
    height?: number, //not required
    weight?: number, //not required

    activityHolidays?: boolean, //not required
    nameActivityHolidays?: string, //not required
    sportPraticated?: boolean, //not required
    nameSportPraticated?: string, //not required

    validatedMedicalCertificate?: boolean, //not required
    validatedDateMedicalCertificate?: Date, //not required
    certifFile?: File,

    hasParentalAuthorization?: boolean,
    yearsValidationDate?: Date,

    medicalQuestionnaire?: MedicalQuestionnaire

  } = {};

    get sdlvTabs() {
        return this._sdlvTabs;
    }

    get sdlvTabsOther() {
        return this._sdlvTabsOther;
    }

    resetAll() {
        this.clearRegisterEvent();
        this.dataCurrentUser = new BehaviorSubject(null);
        this.currentUserMessager = this.dataCurrentUser.asObservable();
        this.listOfAllEvent = new BehaviorSubject([]);
        this.currentListOfAllEvent = this.listOfAllEvent.asObservable();
    }

    setRegisterEvent(event: Event[], key: number) {
    // Type correctement le statut de l'event
        event.forEach(value => {
            value.status = this.formatService.formatReverseStatutEvent(`${value.status}`);
        });

        this._registerEvent.set(key, event);
        this.setAction();
    }

    getRegisterEvent() {
        return this._registerEvent;
    }

    clearRegisterEvent() {
        return this._registerEvent.clear();
    }

    removeRegisterEvent(key: number) {
        this._registerEvent.delete(key);
        this.setAction();
    }

    resetRegisterEvent() {
        this._registerEvent.clear();
        this.setAction();
    }

    changeCurrentUser(user: User) {
        this.dataCurrentUser.next(user);
    }

    getCurrentUser(): User {
        return this.dataCurrentUser.getValue();
    }

    changeCurrentListOfAllEvent(events: Event[]) {
        this.listOfAllEvent.next(events);
    }

    getCurrentListOfAllEvent(): Event[] {
        return this.listOfAllEvent.getValue();
    }

    setAction() {
        this.sdlvTabs.activity = this.flattenMap();
        if (!this.sdlvTabs.activity || this.sdlvTabs.activity.length === 0) {
            if (this.getCurrentUser()
        && this.getCurrentUser().listOfYears
        && this.getCurrentUser().listOfYears.length > 0
        && this.getCurrentUser().listOfYears[0]
            ) {
                this.sdlvTabs.activity = this.getCurrentUser().listOfYears[0].listOfRegisteredEvent;
            }
        }
    }

    /** Autre inscription **/

    resetAllOther() {
        this.clearRegisterEventOther();
        this.dataCurrentUserOther = new BehaviorSubject(null);
        this.currentUserMessagerOther = this.dataCurrentUserOther.asObservable();
        this.listOfAllEventOther = new BehaviorSubject([]);
        this.currentListOfAllEventOther = this.listOfAllEventOther.asObservable();
    }

    setRegisterEventOther(event: Event[], key: number) {
    // Type correctement le statut de l'event
        event.forEach(value => {
            value.status = this.formatService.formatReverseStatutEvent(`${value.status}`);
        });

        this.registerEventOther.set(key, event);
        this.setActionOther();
    }

    getRegisterEventOther() {
        return this.registerEventOther;
    }

    clearRegisterEventOther() {
        return this.registerEventOther.clear();
    }

    removeRegisterEventOther(key: number) {
        this.registerEventOther.delete(key);
        this.setActionOther();
    }

    resetRegisterEventOther() {
        this.registerEventOther.clear();
        this.setActionOther();
    }

    changeCurrentUserOther(user: User) {
        this.dataCurrentUserOther.next(user);
    }

    getCurrentUserOther(): User {
        return this.dataCurrentUserOther.getValue();
    }

    changeCurrentListOfAllEventOther(events: Event[]) {
        this.listOfAllEventOther.next(events);
    }

    getCurrentListOfAllEventOther(): Event[] {
        return this.listOfAllEventOther.getValue();
    }

    setActionOther() {
        this.sdlvTabsOther.activity = this.flattenMapOther();
        if (!this.sdlvTabsOther.activity || this.sdlvTabsOther.activity.length === 0) {
            if (this.getCurrentUserOther()
        && this.getCurrentUserOther().listOfYears
        && this.getCurrentUserOther().listOfYears.length > 0
        && this.getCurrentUserOther().listOfYears[0]
            ) {
                this.sdlvTabsOther.activity = this.getCurrentUserOther().listOfYears[0].listOfRegisteredEvent;
            }
        }
    }

    saveInDb(youngEdited: YoungEditInformationDto) {

        //ajoute les dateStart et dateEnd en fonction de la date limit si création
        if (youngEdited.schoolLevel && !youngEdited.schoolLevel.id) {

            const date = new Date();
            if (date < dateInscription.limitDate) {
                youngEdited.schoolLevel.dateStart = new Date(dateInscription.limitDate.getFullYear() - 1, 8, 1);
                youngEdited.schoolLevel.dateEnd = new Date(dateInscription.limitDate.getFullYear(), 7, 31);
            } else {
                youngEdited.schoolLevel.dateStart = new Date(dateInscription.limitDate.getFullYear(), 8, 1);
                youngEdited.schoolLevel.dateEnd = new Date(dateInscription.limitDate.getFullYear() + 1, 7, 31);
            }
        }
        this.youngWS.updateYoung(youngEdited).subscribe();
    }

    private flattenMap(): unknown[] {
        let newArray = [];
        if (this._registerEvent && this._registerEvent.size > 0) {
            this._registerEvent.forEach((value: unknown[]) => {
                newArray = newArray.concat(...value);
            });
        }


        return newArray;
    }

    private flattenMapOther(): unknown[] {
        let newArray = [];
        if (this.registerEventOther && this.registerEventOther.size > 0) {
            this.registerEventOther.forEach((value: unknown[]) => {
                newArray = newArray.concat(...value);
            });
        }


        return newArray;
    }
}
